import styled from '@emotion/styled';
import { Stack, Typography, colors } from '@ui-components/neo.tax';
import { ReactComponent as LogoIcon } from '@ui-components/neo.tax/dist/icons/logo.svg';

import { Breakpoints, screenMd } from '@neo.tax/shared/utils';

export const BlockerContainer = styled(Stack)(
  {
    backgroundColor: colors.gray['100'],
    padding: '4rem',
    height: '100vh',
  },
  screenMd({
    padding: '1.5rem',
  }),
);

export const Logo = styled(LogoIcon)({ overflow: 'visible', color: colors.primary[600], maxWidth: 230 });

export const BlockerTextContainer = styled(Stack)(screenMd({ gap: '0.5rem' }));

export const BlockerTitle = styled(Typography)(
  {
    color: colors.black,
  },
  screenMd({
    fontSize: '1.5rem',
  }),
);

export const BlockerSubtitle = styled(Typography)(
  {
    color: colors.black,
    maxWidth: Breakpoints.MD,
  },
  screenMd({
    fontSize: '1rem',
    lineHeight: '1.5rem',
  }),
);
